module.exports = __webpack_public_path__ + "static/media/taimalishanicon.56225f2f.webp";